module.exports = __webpack_public_path__ + "static/media/statistics.cb60f3d7.svg";